import * as React from "react";
import { forwardRef } from "react";
const SvgUnderline = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-underline-icon lucide-underline", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M6 4v6a6 6 0 0 0 12 0V4" }), /* @__PURE__ */ React.createElement("line", { x1: 4, x2: 20, y1: 20, y2: 20 }));
const ForwardRef = forwardRef(SvgUnderline);
export default ForwardRef;
